module.exports = __webpack_public_path__ + "static/media/5.b7db3435.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/5.png
// module id = 1326
// module chunks = 0